import React, {FC, useEffect} from 'react';
import {
	AgentState,
	BarVisualizer,
	useVoiceAssistant,
} from '@livekit/components-react';
import classNames from 'classnames';

import * as styles from './styles.module.scss';

type VoiceBarProps = {
	onState: (state: AgentState) => void
}

export const VoiceBars: FC<VoiceBarProps> = ({onState}) => {
	const {state, audioTrack} = useVoiceAssistant();

	useEffect(() => {
		onState(state);
	}, [state]);

	return (
		<div className={classNames({
			[styles.bars]: true,
			[styles.listening]: state === 'listening',
			[styles.speaking]: state === 'speaking',
		})}>
			<BarVisualizer
				className={styles.dynamic}
				state={state}
				barCount={7}
				trackRef={audioTrack}
			/>
		</div>
	);
};
